import Blue from '~/core'

new Blue({
  name: 'Floating Tab',
  selector: '.floating-tab__modal',
  setup(modal) {
    const btns = document.querySelectorAll('[data-floating-modal="open"]')
    const closeBtns = document.querySelectorAll('[data-floating-modal="close"]')

    const toggleModal = (event) => {
      event.preventDefault()
      document.body.classList.toggle('fixed')
      modal.classList.toggle('show')
    }

    btns.forEach((btn) => {
      btn.addEventListener('click', toggleModal)
    })

    closeBtns.forEach((btn) => {
      btn.addEventListener('click', toggleModal)
    })

    window.addEventListener('click', (event) => {
      if (event.target === modal) {
        toggleModal()
      }
    })
  },
})
